import { AbstractService } from '@uniqoders/sdk';

export default class GuiderService extends AbstractService {
  /**
   * Retrieve paginated CMS guiders for an agency
   */
  public listCmsGuiders(agency: string, params: Record<string, any> = {}): Promise<any> {
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/guiders', { agency }),
      params,
    });
  }

  /**
   * Retrieve a single CMS guider
   */
  public getCmsGuider(agency: string, cmsGuiderId: number, options: Record<string, any> = {}): Promise<any> {
    const { headers, params } = options;
    return this.request({
      method: 'get',
      url: this.buildPath('/v2/{agency}/cms/guiders/{cmsGuiderId}', { agency, cmsGuiderId }),
      params,
      headers,
    });
  }

  /**
   * Create a new CMS guider
   */
  public createCmsGuider(agency: string, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/guiders', { agency }),
      data,
    });
  }

  /**
   * Update an existing CMS guider
   */
  public updateCmsGuider(agency: string, cmsGuiderId: number, data: Record<string, any>): Promise<any> {
    return this.request({
      method: 'patch',
      url: this.buildPath('/v2/{agency}/cms/guiders/{cmsGuiderId}', { agency, cmsGuiderId }),
      data,
    });
  }

  /**
   * Delete a CMS guider
   */
  public deleteCmsGuider(agency: string, cmsGuiderId: number): Promise<any> {
    return this.request({
      method: 'delete',
      url: this.buildPath('/v2/{agency}/cms/guiders/{cmsGuiderId}', { agency, cmsGuiderId }),
    });
  }

  /**
   * Publish or unpublish a CMS guider
   */
  public publishCmsGuider(
    agency: string,
    cmsGuiderId: number,
    data: { is_public: boolean },
  ): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/guiders/{cmsGuiderId}/publish', { agency, cmsGuiderId }),
      data,
    });
  }

  /**
   * Upload a featured image via multipart form-data
   */
  public uploadFeaturedImage(agency: string, cmsGuiderId: number, data: FormData): Promise<any> {
    return this.request({
      method: 'post',
      url: this.buildPath('/v2/{agency}/cms/guiders/{cmsGuiderId}/upload-featured', { agency, cmsGuiderId }),
      data,
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  }
}

